var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#FFE206"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1667 14.9997C24.1667 20.0597 20.06 24.1663 15 24.1663C9.94 24.1663 5.83333 20.0597 5.83333 14.9997C5.83333 9.93967 9.94 5.83301 15 5.83301C20.06 5.83301 24.1667 9.93967 24.1667 14.9997Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4008 17.9146L15.5592 16.2188C15.0642 15.9255 14.6608 15.2196 14.6608 14.6421V10.8838",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferTime);
export default __webpack_public_path__ + "static/media/TransferTime.f24c3aeab3ac73c3fad3f3a4aeb96784.svg";
export { ForwardRef as ReactComponent };